function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _Downloader_brand = /*#__PURE__*/new WeakSet();
class Downloader {
  constructor() {
    _classPrivateMethodInitSpec(this, _Downloader_brand);
  }
  createImageSrc(base64) {
    const getImageType = () => {
      if (base64.startsWith('/9j/4')) {
        return 'jpg';
      }
    };
    const imageType = getImageType();
    return `data:image/${imageType};base64,${base64}`;
  }
  download(content, fileName) {
    const fileType = _assertClassBrand(_Downloader_brand, this, _getFileType).call(this, fileName);
    const href = _assertClassBrand(_Downloader_brand, this, _createHref).call(this, fileType, encodeURIComponent(content));
    const a = document.createElement('a');
    a.setAttribute('href', href);
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
function _getFileType(filename) {
  const split = filename.split('.');
  const lastItem = split[split.length - 1];
  return lastItem;
}
function _createHref(fileType, content) {
  switch (fileType) {
    case 'csv':
      return _assertClassBrand(_Downloader_brand, this, _createCSVHref).call(this, content);
    default:
      return `data:application/octet-stream;base64,${content}`;
  }
}
function _createCSVHref(csv) {
  const universalBOM = "\uFEFF";
  const excelUtf8ForcedCsv = universalBOM + csv;
  return `data:text/csv;,${excelUtf8ForcedCsv}`;
}
const downloader = new Downloader();
export { downloader };